(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('RoleListController', RoleListController);
    

    RoleListController.$inject = [
  
    ];

     function RoleListController(){
        // jshint maxstatements:false

        var row = { 
            'role' : 'Administrador', 
            'actions' : 'editar | eliminar'
        };
        
        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
             columnDefs: [

                {
                    field: 'role',
                    displayName: 'Rol',
                    resizable: true
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                }

             ],
             data: vm.gridData,
        };

        (function () {
            loadData();
        })();

        function loadData(){
            for(var i = 0; i < 15; i++){
                vm.gridData.push(row);
            }
        }
    }

})();